// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "v0.0.5-220-g263321a-dirty",
    "hash": "g263321a",
    "distance": 220,
    "tag": "v0.0.5",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v0.0.5",
        "major": 0,
        "minor": 0,
        "patch": 5,
        "prerelease": [],
        "build": [],
        "version": "0.0.5"
    },
    "suffix": "220-g263321a-dirty",
    "semverString": "0.0.5+220.g263321a",
    "version": "1.0.0"
};
/* tslint:enable */
